import React, { useState, useEffect, Fragment } from 'react';
import { PROJECTNAMEALIAS, NFTAPIBASENAME, NFTIMAGEBASEURL, PROJECTCLIENTSIDEURL, PAYBITOAPIBASENAME, PROJECTLOGOPRIMARY } from '../helpers/Setup'
import NFTMarketplace from '../helpers/Marketplace.json';
import { useHistory, NavLink, Link } from 'react-router-dom';
import { handleLogout, getAllSessionData, getCartCount, manipulateCartAfterLoggedIn, handleCartManipulation, showToast, showConfirmPurchase, callAPI, showHttpError, setSessionData, getCartDataAfterLoggedIn } from '../helpers/Library';
import metamask from '../assets/img/png/meta-mask.png'
import { ethers } from "ethers";
import web3 from "web3"
import MetaMaskOnboarding from "@metamask/onboarding";
import { Seaport } from "@opensea/seaport-js";
import { Chain, OpenSeaSDK } from "opensea-js";
import Loader from '../commons/Loader';
import { connect } from 'react-redux';
import store from '../redux/store'
import { setMetaMask, setBlockChainContract } from "../redux/action"
import { useDispatch } from 'react-redux';
import { stringify } from 'flatted';
import Cookies from "js-cookie";



const Header = (props) => {
    const history = useHistory();
    const dispatch = useDispatch()
    const [showLoader, setShowLoader] = useState(false);
    const [isProfileSectionDropdownOpen, setProfileSectionDropdown] = useState(false);
    const [showCart, setShowCart] = useState(false);
    const [isLoggedIn, setLoggedInStatus] = useState(false);
    const [isLoggedInWithExchange, setLoggedInWithExchangeStatus] = useState(false);
    const [isLoggedInWithMetaMask, setLoggedInWithMetaMaskStatus] = useState(false);
    const [showUserDropdown, setUserDropdownStatus] = useState(false);
    const [loggedInUserName, setLoggedInUserName] = useState('');
    const [cart, setCart] = useState([]);
    const [showLoggedInPopup, setLoggedInPopup] = useState(false)
    const [account, setAccount] = useState();
    const [chainID, setChainID] = useState();
    const [networkName, setNetworkName] = useState();
    const [provider, setProvider] = useState();
    const [baseDomain, setbaseDomain] = useState(window.location.origin);
    const [exchangeLogo, setExchangeLogo] = useState(localStorage.getItem('nftBrokerlogo'));



    // setbaseDomain(window.location.origin)


    /* Method defination for connect with meta mask sdk */
    const connectWithMetaMask = async () => {
        //console.log(props.store.metaMask.metamask.isLoggedIn)
        if (window.ethereum && window.ethereum.isMetaMask) {
            console.log("MetaMask Here!");
            //setLoading(true)


                try {
                  await window.ethereum.request({ method: 'eth_requestAccounts' });
                  const Web3 = new web3(window.ethereum);
                  const chainId = await Web3.eth.getChainId();
          
                  if (chainId !== 1) {
                    try {
                        console.log('in TRY')
                      await window.ethereum.request({
                        method: 'wallet_switchEthereumChain',
                        params: [{ chainId: '0x1' }],
                      });
                    } catch (switchError) {
                        console.log(switchError);
                      if (switchError.code === 4902) {
                        await window.ethereum.request({
                          method: 'wallet_addEthereumChain',
                          params: [{
                            chainId: '0x1',
                            chainName: 'Ethereum Miannet',
                            rpcUrls: ['https://eth-mainnet.g.alchemy.com/v2/pQJX2H6GKUq1SR1kvbTDzWKYHFTpXSFu'],
                            nativeCurrency: {
                              name: 'Ether',
                              symbol: 'ETH',
                              decimals: 18,
                            },
                            blockExplorerUrls: ['https://etherscan.io'],
                          }],
                        });
                      } else {
                        console.error(switchError);
                      }
                    }
                  }
          
                  window.web3 = Web3;
                  getMetaMaskUserAccounts();
                } catch (error) {
                  console.error('User denied account access', error);
                  showToast('error',error.message)
                }
              
          

        } else {
            showToast('error', "Please install MetaMask to proceed");
            let metamask = { isLoggedIn: false, isInstalled: false, credentials: {} }
            dispatch(setMetaMask(metamask))
            //onboarding.startOnboarding();
        }

    };

    const getAndSetMetamaskAccount = async () => {

        if (window.ethereum) {
            try {
                // Request account access
                const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
                console.log('Accounts:', accounts);
                setLoggedInUserName(accounts[0])
                setSessionData('account', accounts[0]);
            } catch (err) {
                setShowLoader(true)
                setSessionData('account', getAllSessionData().firstName)
                setSessionData('isLoggedInMetaMask', 'false')
                setLoggedInUserName(getAllSessionData().firstName)
                showToast('error', 'User denied account access or MetaMask is not connected.');
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            }
        } else {
            showToast('error', 'MetaMask is not installed');
        }

        
    }

    /* Method defination get user details */
    const getMetaMaskUserAccounts = async () => {
        try {
            setShowLoader(true)
            const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
            const account = accounts[0];
            console.log('ACCOUNT => ', account)
            const message = [
                "This site is requesting your signature to approve login authorization!",
                "I have read and accept the terms and conditions (" + baseDomain + "/nft-marketplace) of this app.",
                "Please sign me in!"
            ].join("\n\n")

            const chainId = Number(await window.ethereum.request({ method: "eth_chainId" }));
            const network = ethers.providers.getNetwork(chainId);
            //console.log(`Network name: ${network.name}, id:${network.chainId}`);
            const sign = await window.ethereum.request({ method: 'personal_sign', params: [message, account] })

            setChainID(network.chainId.toString())
            setNetworkName(network.name.toUpperCase())

            console.log(account)
            setAccount(account);
            localStorage.setItem(PROJECTNAMEALIAS + "meta_mask_sign", sign)
            setProvider(new ethers.providers.Web3Provider(window.ethereum));
            setLoggedInStatus(true)
            setLoggedInUserName(account)
            let metamask = {
                isLoggedIn: true, isInstalled: true, credentials: {
                    account: account,
                    chainId: network.chainId,
                    networkName: network.name
                }
            }
            //props.setMetaMask(metamask)
            dispatch(setMetaMask(metamask))
            //getCartDataAfterLoggedIn()
            setTimeout(() => {
                let obj = {
                    account: account,
                    chainId: network.chainId,
                    networkName: network.name
                }

                //setSessionData('uuid', response.nftUser.userUuid)
                //setSessionData('token', response.accessToken)
                setSessionData('account', account)
                setSessionData('chainId', network.chainId)
                setSessionData('networkName', network.name)
                //setSessionData('loginPlatform', 'metamask')
                setSessionData('isLoggedInMetaMask', 'true')
                setLoggedInWithMetaMaskStatus(true)
                setLoggedInStatus(true);
                setLoggedInPopup(false);
                window.location.reload();
                setShowLoader(false)

            }, 4000);
        } catch (error) {
            showToast('error', 'Error loading accounts');
            setShowLoader(false)
            showToast('error', 'Error loading accounts' + error);
        }


    }




    /* Method defination for metamask account logout */
    const handleMetaMaskLogout = () => {
        setShowLoader(true)
        localStorage.removeItem(PROJECTNAMEALIAS + "meta_mask_sign")
        localStorage.removeItem(PROJECTNAMEALIAS + 'session');
        setLoggedInStatus(false);
        setAccount(null);
        setShowLoader(false)
        setLoggedInWithExchangeStatus(false)
        setLoggedInWithMetaMaskStatus(false)
    };



    

    /* method defination for setting all cart data after login */
    let setAllCartItemAfterLoggedIn = () => {
        if (localStorage.getItem(PROJECTNAMEALIAS + 'cart') != undefined && localStorage.getItem(PROJECTNAMEALIAS + 'cart') != 'undefined' && localStorage.getItem(PROJECTNAMEALIAS + 'cart') != null) {
            let cart = JSON.parse(localStorage.getItem(PROJECTNAMEALIAS + 'cart'));
            // console.log(cart)
            if (cart != null) {
                for (let i = 0; i < cart.length; i++) {
                    manipulateCartAfterLoggedIn(cart[i].id, 'add');
                }
            }
        }
    }


    /* Method defination for get all cart total price */
    let getTotalPrice = () => {
        let cart = JSON.parse(localStorage.getItem(PROJECTNAMEALIAS + 'cart'));
        // console.log(cart)
        let sum = 0
        if (cart != null) {
            for (let i = 0; i < cart.length; i++) {
                if (!isNaN(cart[i].price)) {

                    sum = sum + parseFloat(cart[i].price);
                }
            }
        }
        return sum;
    }

    /* method defination for initialize cart  */
    let initializeCart = () => {
        let cart = localStorage.getItem(PROJECTNAMEALIAS + 'cart');
        if (cart != null && cart != undefined && cart != '') {
            setCart(JSON.parse(localStorage.getItem(PROJECTNAMEALIAS + 'cart')));
        } else {
            setCart([])
        }
    }

    /* Method defination for handle checkout */
    let handleCheckout = () => {
        if (
            getAllSessionData() != undefined &&
            getAllSessionData() != 'undefined' &&
            getAllSessionData() != null &&
            getAllSessionData() != 'null'
        ) {

            window.location.href = PROJECTCLIENTSIDEURL + '/checkout';
        } else {
            showToast('error', 'Please login to continue');
        }
    }

    let geBrokerDetails = () => {
        // setShowLoader(true)
        // let payload = { "address": obj.account, "networkId": obj.chainId, "isExternal": 1 }
        let exchangeDomain = window.location.origin
        if(exchangeDomain.indexOf('localhost') != -1){
            exchangeDomain = 'https://trade.paybito.com/'
        }
        //console.log(localStorage.getItem('nftBrokerId'), Cookies.get(PROJECTNAMEALIAS + "broker_id"))
        if((localStorage.getItem('nftBrokerId') === undefined || localStorage.getItem('nftBrokerId') === 'undefined') && Cookies.get(PROJECTNAMEALIAS + "broker_id") === undefined){
            window.location.href = localStorage.getItem('nftBrokerloginRedirectionDomain')
            return;
        }
        const brokerId = localStorage.getItem('nftBrokerId') != undefined && localStorage.getItem('nftBrokerId') != 'undefined' ? localStorage.getItem('nftBrokerId') : Cookies.get(PROJECTNAMEALIAS + "broker_id") !== undefined ? Cookies.get(PROJECTNAMEALIAS + "broker_id") : 'PAYB18022021121103';
        callAPI('get', `https://accounts.paybito.com/api/home/getBrokerWiseExchangeInfo?brokerId=${brokerId}`, false).then((res) => {
            let response = res.data.value[0];

            console.log('brokerrsss', response);

            localStorage.setItem('nftBrokerExchangeName', response.exchange)
            localStorage.setItem('nftBrokerCompanyName', response.company_name)
            console.log(localStorage.getItem('nftBrokerExchangeName').toLowerCase())
            if(localStorage.getItem('nftBrokerExchangeName').toLowerCase() === 'paybito'){
               // console.log('in if')
                 localStorage.setItem('nftBrokerlogo', 'https://www.paybito.com/wp-content/themes/paybito-theme/images/logo-white-paybito.png')
            }else{
                //console.log('in else')
               localStorage.setItem('nftBrokerlogo', response.exchange_logo)
            }
            setExchangeLogo(localStorage.getItem('nftBrokerlogo'))
            localStorage.setItem('nftBrokerId', response.broker_id)
            localStorage.setItem('nftBrokerDomain', window.location.origin)
            localStorage.setItem('nftBrokerloginRedirectionDomain', window.location.origin + '?login-for=nft')










        }, (error) => {
            setShowLoader(false);
            showHttpError(error)
        })
    }

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {


        geBrokerDetails()

        
        if (
            getAllSessionData() != undefined &&
            getAllSessionData() != 'undefined' &&
            getAllSessionData() != null &&
            getAllSessionData() != 'null'
        ) {
            setLoggedInStatus(true)
            if (getAllSessionData().isLoggedInExchange == 'true') {
                setLoggedInWithExchangeStatus(true)
                if (getAllSessionData().isLoggedInMetaMask == 'true') {
                    setLoggedInWithMetaMaskStatus(true)
                    getAndSetMetamaskAccount();
                } else {
                    const normalizedUrl = window.location.href.replace(/^https?:\/\//i, '').toLowerCase();
                    const isMyExchange = normalizedUrl.startsWith('portal.paybito.com');
                    //TODO: if isMyExchange is true, then setLoggedInPopup to false & isLoggedinMetaMask as true
                    setLoggedInPopup(true)
                    setSessionData('account', getAllSessionData().firstName)
                    setSessionData('isLoggedInMetaMask', 'false')
                    setLoggedInUserName(getAllSessionData().firstName)
                }
            } else {
                setLoggedInPopup(true)
            }

            setLoggedInUserName(getAllSessionData().account);

        } else {
            setLoggedInStatus(false)
            setLoggedInPopup(true)
        }


        setTimeout(() => {
            let link = document.querySelector("link[rel~='icon']");
            if (!link) {
                link = document.createElement('link');
                link.rel = 'icon';
                document.getElementsByTagName('head')[0].appendChild(link);
            }
            link.href = localStorage.getItem('nftBrokerlogo');
        }, 3000);
    }, [loggedInUserName]);


    return (
        <Fragment>
            {/*   Start Main Top */}
            <div className="main-top">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div className="custom-select-box">
                                <select id="basic" className="selectpicker show-tick form-control" data-placeholder="$ USD">
                                    <option>¥ JPY</option>
                                    <option>$ USD</option>
                                    <option>€ EUR</option>
                                </select>
                            </div>
                            <div className="right-phone-box">
                                <p>Call US :- <a href="#"> +11 900 800 100</a></p>
                            </div>
                            <div className="our-link">
                                <ul>
                                    <li><a href="#"><i className="fa fa-user s_color"></i> My Account</a></li>
                                    <li><a href="#"><i className="fas fa-location-arrow"></i> Our location</a></li>
                                    <li><a href="#"><i className="fas fa-headset"></i> Contact Us</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div className="login-box">
                                <select id="basic" className="selectpicker show-tick form-control" data-placeholder="Sign In">
                                    <option>Register Here</option>
                                    <option>Sign In</option>
                                </select>
                            </div>
                            <div className="text-slid-box">
                                <div id="offer-box" className="carouselTicker">
                                    {/*  <ul className="offer-box">
                                <li>
                                    <i className="fab fa-opencart"></i> 20% off Entire Purchase Promo code: offT80
                                </li>
                                <li>
                                    <i className="fab fa-opencart"></i> 50% - 80% off on Vegetables
                                </li>
                                <li>
                                    <i className="fab fa-opencart"></i> Off 10%! Shop Vegetables
                                </li>
                                <li>
                                    <i className="fab fa-opencart"></i> Off 50%! Shop Now
                                </li>
                                <li>
                                    <i className="fab fa-opencart"></i> Off 10%! Shop Vegetables
                                </li>
                                <li>
                                    <i className="fab fa-opencart"></i> 50% - 80% off on Vegetables
                                </li>
                                <li>
                                    <i className="fab fa-opencart"></i> 20% off Entire Purchase Promo code: offT30
                                </li>
                                <li>
                                    <i className="fab fa-opencart"></i> Off 50%! Shop Now 
                                </li>
                            </ul> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* End Main Top */}

            {/* Start Main Top */}
            <header className="main-header fixed-menu">
                {/* Start Navigation */}
                <nav className="navbar navbar-expand-lg navbar-light bg-light navbar-default bootsnav">
                    <div className="container">
                        {/* Start Header Navigation */}
                        <div className="navbar-header">
                            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar-menu" aria-controls="navbars-rs-food" aria-expanded="false" aria-label="Toggle navigation">
                                <i className="fa fa-bars"></i>
                            </button>
                            <div className="row">
                                <div className="col-md-4 col-lg-4 col-sm-12 col-xs-12">
                                    <Link className="navbar-brand" to={'/'}>
                                        <div className="image-container">
                                            <img src={exchangeLogo} className="logo" alt="" loading="lazy" />
                                        </div>
                                    </Link>
                                </div>
                                <div className="col-md-8 col-lg-8 col-sm-12 col-xs-12 header-name">
                                    <h1><Link to={'/'}> NFT Marketplace</Link></h1>
                                </div>
                            </div>


                        </div>
                        {/* End Header Navigation */}

                        {/* Collect the nav links, forms, and other content for toggling */}
                        <div className="collapse navbar-collapse" id="navbar-menu">
                            <ul className="nav navbar-nav ml-auto" data-in="fadeInDown" data-out="fadeOutUp">
                                {/* <li className="nav-item active"><a className="nav-link" href="index.html">Home</a></li>
                                <li className="nav-item"><a className="nav-link" href="about.html">About Us</a></li>
                                <li className="dropdown">
                                    <a href="#" className="nav-link dropdown-toggle arrow" data-toggle="dropdown">SHOP</a>
                                    <ul className="dropdown-menu">
                                        <li><a href="shop.html">Sidebar Shop</a></li>
                                        <li><a href="shop-detail.html">Shop Detail</a></li>
                                        <li><a href="cart.html">Cart</a></li>
                                        <li><a href="checkout.html">Checkout</a></li>
                                        <li><a href="my-account.html">My Account</a></li>
                                        <li><a href="wishlist.html">Wishlist</a></li>
                                    </ul>
                                </li> */}
                                {/* {!isLoggedIn && <li className="nav-item"><a className="nav-link" href="https://trade.paybito.com/?login-for=nft" target="_blank"><i className="fa fa-sign-in" aria-hidden="true"></i>Login</a></li>} */}
                                {!isLoggedIn && <li className="nav-item"><a className="nav-link" href="javascript:void(0)" onClick={() => { setLoggedInPopup(true) }}><i className="fa fa-sign-in" aria-hidden="true"></i>Login</a></li>}
                                {isLoggedIn && <li className="nav-item"><a href="javascript:void(0)" className="nav-link" onClick={() => {
                                    setUserDropdownStatus(!showUserDropdown)
                                }} ><i className="fa fa-user-circle" aria-hidden="true"></i> {loggedInUserName} <i className={`fa ${ showUserDropdown ?'fa-caret-up':'fa-caret-down'}`} aria-hidden="true"></i></a>
                                    <ul className={`dropdown-menu ${showUserDropdown ? 'show' : ''}`} style={{ paddingLeft: '14px' }}>
                                        {/* <li> <Link to={`/profile/${getAllSessionData().uuid}`}>Profile</Link></li> */}
                                        <li><Link to="/collection">Collections</Link></li>
                                        {getAllSessionData() != null && <li><Link to="/create-collection">Create Collection</Link></li>}
                                        {/*  <li><Link to="/my-favorites">Favorites</Link></li> */}
                                        <li><Link to="/create-nft">Create NFT</Link></li>
                                        {/* {getAllSessionData().loginPlatform != 'metamask' && <li><Link to="/non-minted-nft">Non Minted NFT</Link></li>} */}
                                        <li><Link to={`/my-nfts`}>My NFTs</Link></li>
                                    </ul>
                                </li>}
                            </ul>
                        </div>
                        {/* /.navbar-collapse */}

                        {/* Start Atribute Navigation */}
                        <div className="attr-nav">
                            <ul>
                                {/* <li className="search"><a href="#"><i className="fa fa-search"></i></a></li> */}
                                {/* <li className="side-menu">
                                    <a href="javascript:void(0)" onClick={() => { setShowCart(!showCart); initializeCart(); }}>
                                        <i className="fa fa-shopping-bag"></i>
                                        {getCartCount() > 0 && <span className="badge">{getCartCount()}</span>}
                                        <p>My Cart</p>
                                    </a>
                                </li> */}
                                {isLoggedIn && <li className="side-menu">
                                    {/* {getAllSessionData().loginPlatform == 'paybito' ? <a href="javascript:void(0)" onClick={() => { handleLogout() }}>
                                        <i className="fa fa-sign-out" aria-hidden="true"></i>
                                        <p>Logout</p>
                                    </a> : <a href="javascript:void(0)" onClick={() => { handleMetaMaskLogout() }}>
                                        <i className="fa fa-sign-out" aria-hidden="true"></i>
                                        <p>Logout</p>
                                    </a>} */}
                                    <a href="javascript:void(0)" onClick={() => { handleMetaMaskLogout() }}>
                                        <i className="fa fa-sign-out" aria-hidden="true"></i>
                                        <p>Logout</p>
                                    </a>
                                </li>}
                            </ul>
                        </div>
                        {/* End Atribute Navigation */}
                    </div>
                    {/* Start Side Menu */}
                    <div className={`side ${showCart ? 'on' : ''}`} >
                        <a href="javascript:void(0)" onClick={() => { setShowCart(!showCart) }} className="close-side"><i className="fa fa-times"></i></a>
                        <li className="cart-box" style={{ borderRadius: '5px' }}>
                            <h2 className='ml-2 p-2 bold mb-3'>My Cart</h2>
                            <hr />
                            <ul className="cart-list">
                                {cart.map((nft) => (
                                    <li key={nft.id}>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <a href="javascript:void(0)" className="photo"><img src={NFTIMAGEBASEURL + '/' + nft.image} className="cart-thumb" alt="" /></a>
                                                <h6><a href="#">{nft.name} </a></h6>
                                                <p><span className="price">{nft.price} ETH</span></p>
                                            </div>
                                            <div className="col-md-6 text-right">
                                                <p className='text-danger' title='Remove Item'><span className="price" style={{ cursor: 'pointer' }} onClick={() => { handleCartManipulation(nft, 'delete') }} data-toggle="tooltip" data-placement="right" title="Remove Item"><i className="fa fa-trash" aria-hidden="true"></i></span></p>
                                            </div>
                                        </div>
                                    </li>)
                                )}

                                <li className="total" style={{ borderRadius: '5px' }}>
                                    <a href="javascript:void(0)" className="btn btn-default hvr-hover btn-cart" onClick={() => { handleCheckout() }}>Checkout</a>
                                    <span className="float-right"><strong>Total</strong>: {parseFloat(getTotalPrice())} ETH</span>
                                </li>
                            </ul>
                        </li>
                    </div>
                    {/* End Side Menu */}
                </nav>
                {/* End Navigation */}
            </header>
            {/* End Main Top */}
            {/* Start Top Search */}
            <div className="top-search">
                <div className="container">
                    <div className="input-group">
                        <span className="input-group-addon"><i className="fa fa-search"></i></span>
                        <input type="text" className="form-control" placeholder="Search" />
                        <span className="input-group-addon close-search"><i className="fa fa-times"></i></span>
                    </div>
                </div>
            </div>
            {/* End Top Search */}

            {/* Make offer modal */}
            <Fragment>
                <div className={"modal " + (showLoggedInPopup ? 'show' : '')} tabIndex="-1" role="dialog" style={{ display: showLoggedInPopup ? 'block' : 'none', paddingRight: '17px', background: '#0000008c' }}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Login</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => { setLoggedInPopup(false); }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row text-center">
                                    <div className="col-md-12">
                                        <span>Login with</span>
                                    </div>
                                </div>
                                {!isLoggedInWithExchange && <div className="paybito-login text-center">
                                    <a href={localStorage.getItem('nftBrokerloginRedirectionDomain')} target="_blank"><img className='logo' src={exchangeLogo} /></a>
                                </div>}
                                {/* <div className="text-center" style={{ marginTop: '20px', marginBottom: '20px' }}>Or</div> */}
                                {getAllSessionData() != null && !isLoggedInWithMetaMask && <div className="metamask-login text-center">
                                    <a href="javascript:void(0)" onClick={() => { connectWithMetaMask() }}><img src={metamask} style={{ width: '183px', marginBottom: '30px' }} /></a>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
            <Loader show={showLoader} />
        </Fragment>
    );
}

const mapStateToProps = state => {
    return {
        store: state
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setMetaMask: (obj) => dispatch(setMetaMask(obj)),
    }
}

export default connect(mapStateToProps)(Header)